import React, { Component } from 'react'
import { color, apiUrl } from "../common/constants";
import { getImgPath } from "../common/helper";
import WaitlistInput from "../common/waitlistInput";

import{ fetchPost } from "../../common/common";

import {t, RESULT_NOT_FOUND,TO,PLEASE_MODIFY_SEARCH,OR,REQ_WAITLIST_PRIORITY_BOOKING,REQ_SUBMITTED_SUCCESS,REQ_FOR_WAITLIST_BOOKING,MOBILE_NO,EMAIL,NAME,NO_OF_PASSENGER,APPLY_FOR_WAITLIST_BOOKING,MSG1,MSG2 } from '../../translations/WaitList';

const passenger = [1,2,3,4,5,6];

class waitList extends Component {

    constructor(props) {
        super(props);
        this.state = {
          countryCode :window.country_code,
          mobile:'',
          email:'',
          name:'',
          passenger:'',
          showpassenger:false,
          mobileflag: false,
          emailflag : false,
          showLoader :false,
          alerterror : '',
        };
      }

      componentDidMount(){
        window.addEventListener("click", this.closePassengerDrop)
      }
      
      closePassengerDrop = () => {
          this.setState({showpassenger:false})
      }

      handleMobileNumber = (e) => {
        let mobno = e.target.value;
        const mobRegex = /^[0-9]*$/
        this.setState({mobileflag:false})
        if(mobRegex.test(mobno)|| !mobno){
            this.setState({ mobile:  mobno});
        }

        if(window.msurl === 'shwesanthu.com'){
          if(mobno.length>=7){
            this.setState({mobileflag:true})
          }
        }else{
          if(mobno > 6000000000 && mobno.length == 10){
            this.setState({mobileflag:true})
          }  
          // else{
          //   this.setState({mobileflag:false})
          // }
        }

      };
    
      handleEmail = (e) =>{
        let email = e.target.value;
        const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/
        this.setState({emailflag:false,email:email})
        
        if(emailRegex.test(email)){
          this.setState({emailflag:true})
        }
      }
    
      handleName = (e) =>{
        let name = e.target.value;
        const nameRegex = /^[a-z][a-z ]*$/i;
        if(nameRegex.test(name) || !name){
          this.setState({name:name})
        }
      }
    
      handlePassenger = (e) =>{
        e.stopPropagation();  
        this.setState({showpassenger:true})
      }

      showaertdialogue = () => {
        setTimeout(() => {
          this.setState({ alerterror: "" });
        }, 5000);
        return (
          <div
            className="blacklayer"
            onClick={() => {
              this.setState({ alerterror: "" });
            }}
          >
            <div className="popupbox">
              {/* <div className="circle pixedpos logo-box">
                <GsbLogoBold />
              </div> */}
              <div className="alertmsg">{this.state.alerterror}</div>
              <button
                className="alertbuttonok crsrpointer"
                onClick={() => {
                  this.setState({ alerterror: "" });
                }}
              >
                OK{" "}
              </button>
            </div>
          </div>
        );
      };
    
      handleWaitBooking = () =>{
        let postData = {};
        let departDate = this.props.data.departDate.split('-');
        departDate = departDate[2]+ '-'+departDate[1] + '-'+departDate[0]
        postData['mobileNo']    =  this.state.mobile;
        postData['emailID']     =  this.state.email;
        postData['name']        =  this.state.name;
        postData['seatCount']   =  this.state.passenger;
        postData['fromCityID']  =  this.props.data.fromCity.split("|")[0];
        postData['toCityID']    =  this.props.data.toCity.split("|")[0];
        postData['journeyDate'] =  departDate;
    
        console.log(postData)
    
        const urlWaitList = window.url +'/api/others/paxWaitList';
        this.setState({ showLoader: true });
        fetchPost(urlWaitList, postData).then(data => {
           if(data.isSuccess){
             this.setState({
                   showLoader: false ,
                   showWaitingmsg : true,
                   mobile:'',
                   email:'',
                   name:'',
                   passenger:'',
                });
             
           }
           else{
            this.setState({ showLoader: false ,showWaitingmsg : false, alerterror: data.error}); 
           }
         
        })
        .catch((err) => console.log(err));
    
      }  
    render() {
        let waitflag = this.state.mobileflag && this.state.emailflag && this.state.name && this.state.passenger
        return (
            <div className = "waiting--list--wrapper"> 
             {this.state.alerterror !== "" ? this.showaertdialogue() : ""}
            <div className ="left">
                <div>
                   {t(RESULT_NOT_FOUND)}{" "}
                  <span style={{fontWeight:'500'}}> {this.props.data.fromCity.split("|")[1]} {t(TO)}{" "}
                         {this.props.data.toCity.split("|")[1]}
                   </span>      
                   <br /> 
                   {t(PLEASE_MODIFY_SEARCH)} <br /> {t(OR) } <br /> {t(REQ_WAITLIST_PRIORITY_BOOKING)}
               </div>
               <div>
                 <img
                   src={getImgPath("/img/route-error.png")}
                   style = {{width:'100px'}}
                   alt="mantis logo"
                 />
               </div>
            </div>
            <div className = "right">
               {
                 this.state.showWaitingmsg &&
                  <div className ="success--head">{t(REQ_SUBMITTED_SUCCESS)}</div>
               } 
              <div className ="priority--head">{t(REQ_FOR_WAITLIST_BOOKING)}</div>
              <div className = "priority--input--wrap">
              <div className="priority-info">
                <div>
                   <WaitlistInput
                     type="text"
                     value={this.state.countryCode}
                     name="countrycode"
                     max={8}
                     style={{
                       width: "60px",
                       marginRight: "10px",
                       flexShrink: "0",
                     }}
                     disabled
                     readOnly
                   />
                   </div>
                   <div style = {{width:'calc(100% - 60px)',display:'flex'}}>
                       <WaitlistInput
                         type="text"
                         value={this.state.mobile}
                         handleChange={(event) => this.handleMobileNumber(event)}
                         placeholder={t(MOBILE_NO)}
                         name="mobileNo"
                         tab={1}
                         waitlistborder = {this.state.showWaitingmsg}
                         validation="mobile"
                         style={{ width:'23.33%', marginRight: "10px" }}
                         max={"10"}
                         autoComplete="new-password"
                         
                       />
                       <WaitlistInput
                         type="text"
                         value={this.state.email}
                         handleChange={(e) => this.handleEmail(e)}
                         placeholder={t(EMAIL)}
                         name="email"
                         tab={2}
                         waitlistborder = {this.state.showWaitingmsg}
                         validation="email"
                         style={{width:'30%', marginRight: "10px" }}
                         autoComplete="new-password"
                        
                       />
                       <WaitlistInput
                         type="text"
                         value={this.state.name}
                         handleChange={(e) => this.handleName(e)}
                         placeholder={t(NAME)}
                         name="passengername"
                         tab={3}
                         waitlistborder = {this.state.showWaitingmsg}
                         style={{width:'23.33%',marginRight: "10px" }}
                         autoComplete="new-password"
                       />
                       <div className="passenger---count" style={{width:'23.33%',position:'relative'}}>
                       <WaitlistInput
                         type="text"
                         value={this.state.passenger}
                         handleClick = {(e) => this.handlePassenger(e)}
                         placeholder={t(NO_OF_PASSENGER)}
                         name="pasenger"
                         tab={4}
                         waitlistborder = {this.state.showWaitingmsg}
                         style ={{cursor:'pointer'}}
                         // style ={{width:'23.33%'}}
                         autoComplete="new-password"
                         readOnly

                         
                       /> 
                       {
                         this.state.showpassenger ?
                          <img style={{position:'absolute',right:'7px',top:'19px'}} src = {getImgPath("/img/arrow-tp.png")} alt = 'arrow-tp' />
                          :
                          <img style={{position:'absolute',right:'7px',top:'19px'}} src = {getImgPath("/img/arrow-btm.png")} alt = 'arrow-btm' />  
                       }
                       {
                           this.state.showpassenger && 
                           <div className ="passenger--drop" 
                             style ={{
                                     width:'100%',
                                     position:'absolute',
                                     background:'#fff',
                                     paddingTop:'10px',
                                     boxShadow:'0 1px 3px rgba(0,0,0,0.3)',
                                     borderRadius:'6px'
                                     }}>
                             {
                               passenger.map((el) =>{
                                 let txt = el > 1 ? el+ ' passengers ' : el +' passenger '  
                                 return(
                                   <div key = {el}
                                     className ="passenger--count"
                                     style ={{display: 'flex',alignItems: 'center',padding:'0 10px', height:'25px', cursor:'pointer'}}
                                     onClick = {() => this.setState({showpassenger:false,passenger:el})} 
                                   >
                                     {txt}
                                   </div>
                                 ) 
                                 
                               })
                             }
                           </div>
                        } 
                       </div>
                     </div>
                   </div>
                 <div 
                   className ="waiting--btn"
                   style = {
                             waitflag ? {background:color.secondary}:{background:'#ddd',pointerEvents:'none',color:'#666'}
                   }
                   onClick = {this.handleWaitBooking}
                 >
                   {t(APPLY_FOR_WAITLIST_BOOKING)}
                 </div>
              </div>
              <div className ="note">
                <div style ={{width:'50px'}}>
                  <img  src = {getImgPath("/img/tip.png")} alt = 'tip' />
                </div>
                <div>
                  <p style ={{margin:0}}>{t(MSG1)}</p> 
                  <p style ={{margin:0}}>{t(MSG2)}</p>
                </div>
               
              </div>
            </div>
            {this.state.showLoader ? (
                <div className="show-load">
                    <div className="loading">
                    <span></span>
                    <span></span>
                    <span></span>
                    </div>
                </div>
               ) : (
                ""
             )}
         </div>
        )
    }
}

export default waitList
